import { Link, useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import './Navbar.css'

const Navbar = () => {
  const { pathname } = useLocation()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  // Close the mobile menu whenever we navigate to a new page.
  useEffect(() => {
    setIsMobileMenuOpen(false)
  }, [pathname])

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src="/logo.svg" alt="Vélvirki ehf." />
        </Link>
        
        <button 
          className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        
        <div className={`nav-links mobile ${isMobileMenuOpen ? 'active' : ''}`}>
          <Link to="/" className={pathname === '/' ? 'active' : ''}>
            HEIM
          </Link>
          <Link to="/thjonusta" className={pathname === '/thjonusta' ? 'active' : ''}>
            ÞJÓNUSTA
          </Link>
          <Link to="/um-okkur" className={pathname === '/um-okkur' ? 'active' : ''}>
            UM OKKUR
          </Link>
          <Link to="/hafa-samband" className={pathname === '/hafa-samband' ? 'active' : ''}>
            HAFA SAMBAND
          </Link>
        </div>
      </div>
    </nav>
  )
}

export default Navbar